import { ClientType, selectUser, useRainCorporateFormContext, useStoreClient } from "@usher/pe-client-front-end-lib"
import { clsx } from "clsx"
import { Check } from "lucide-react"
import { useEffect, useRef } from "react"

import { NavLink, Route, Switch, useHistory, useLocation, useParams, useRouteMatch } from "react-router-dom"
import { Agreement, BusinessOffer, CompanyAddress, CompanyInfo, ContactDetails, Documents } from "./forms/rain"
import { getLink } from "./getLink"
import { GET_RAIN_LINKS } from "./links"

const CompanyInfoRoutes = ({ basePath }: { basePath: string }) => {
  const loadedRef = useRef(false)
  const { loadCompanyInfo } = useRainCorporateFormContext()

  useEffect(() => {
    if (loadedRef.current) return
    loadedRef.current = true
    loadCompanyInfo()
  }, [loadCompanyInfo])

  return (
    <Switch>
      <Route path={`${basePath}`} exact component={CompanyInfo} />
      <Route path={`${basePath}/company-address`} component={CompanyAddress} />
      <Route path={`${basePath}/company-contact-details`} component={ContactDetails} />
    </Switch>
  )
}

export const RainForm = () => {
  const { client_type, entity_id, tax_id } = useStoreClient(selectUser)
  const { valid, verification } = useRainCorporateFormContext()
  const history = useHistory()
  const { path } = useRouteMatch()
  const pathname = useLocation().pathname
  const { type } = useParams<{ type: string }>()
  const isCorporateAccount = client_type === ClientType.Coroporate
  useEffect(() => {
    if (isCorporateAccount) {
      if (type === "exchange" && pathname.includes("get-link")) history.push(getLink(type, void 0, true))
    } else {
      if (type === "card" && ["set-your-wallet", "proof-of-card", "get-link"].some((path) => pathname.includes(path))) history.push(getLink(type))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, type, isCorporateAccount])
  const LINKS = GET_RAIN_LINKS()
  return (
    <div className="additional-form center">
      <div className="box box-light">
        <ul className="nav nav-pills application-form__tutorial flex-column align-items-start">
          {LINKS.map(({ route, title }, key) => {
            let isValid = ["company-address", "company-contact-details"].includes(route) || false
            if (route === "") isValid = Boolean(entity_id) && Boolean(tax_id)
            if (route === "add-ubo") isValid = valid.ubo
            if (route === "add-representatives") isValid = valid.representative
            if (route === "add-business-offer") isValid = valid.officer
            if (route === "documents") isValid = ["21", "18", "22", "19"].every((id) => verification?.[id])
            return (
              <li key={key} className="application-form__tutorial-name flex items-center justify-between w-full">
                <NavLink to={`/company-verification/form/${route}`} exact className="application-form__tutorial-link dark-link">
                  {String(key + 1).padStart(2, "0")}. {title}
                </NavLink>
                <div
                  className={clsx("w-6 h-6 flex items-center justify-center  text-white rounded-sm", {
                    "bg-gray-100": !isValid,
                    "bg-green-600": isValid,
                  })}
                >
                  {isValid && <Check size={16} />}
                </div>
              </li>
            )
          })}
        </ul>
        <div className="tab-content pt-4">
          <Switch>
            <Route
              path={[`${path}`, `${path}/company-address`, `${path}/company-contact-details`]}
              exact
              render={() => <CompanyInfoRoutes basePath={path} />}
            />
            <Route path={`${path}/documents`} component={Documents} />
            <Route path={`${path}/add-business-offer`}>
              <BusinessOffer key="add-business-offer" type="add-business-offer" />
            </Route>
            <Route path={`${path}/add-ubo`}>
              <BusinessOffer key="add-ubo" type="add-ubo" />
            </Route>
            <Route path={`${path}/add-representatives`}>
              <BusinessOffer key="add-representatives" type="add-representatives" />
            </Route>
            <Route path={`${path}/agreement`} component={Agreement} />
          </Switch>
        </div>
      </div>
    </div>
  )
}
